import React, { useState } from 'react';
import api from '../services/api';
import AdminPasswordModal from './AdminPasswordModal';
import './AuditLog.css';

function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(true);

  const fetchLogs = async (password) => {
    if (!password) {
      setError('Admin password is required to view audit logs.');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('password', password);

      const response = await api.post('/audit-logs', formData);
      setLogs(response.data);
      setShowModal(false);
    } catch (err) {
      setError('Failed to fetch audit logs. Please check the admin password.');
      console.error(err);
      // Keep the modal open on failure
    }
  };

  if (showModal) {
    return (
      <AdminPasswordModal
        onConfirm={fetchLogs}
        onCancel={() => {
          setShowModal(false);
          setError('Audit log access cancelled.');
        }}
      />
    );
  }

  return (
    <div className="audit-log-container">
      <h2>Audit Log</h2>
      {error && <p className="error">{error}</p>}
      <table className="audit-log-table">
        <thead>
          <tr>
            <th>Timestamp</th>
            <th>User</th>
            <th>Action</th>
            <th>Details</th>
            <th>Client IP</th>
            <th>Client Machine Name</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log) => (
            <tr key={log.id}>
              <td>{new Date(log.timestamp).toLocaleString()}</td>
              <td>{log.user}</td>
              <td>{log.action}</td>
              <td>{log.details}</td>
              <td>{log.client_ip}</td>
              <td>{log.client_machine_name}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AuditLog;